export default {
    PROCESS_RES: (state, data) => {
        // if no limit in response - it means that all form was fetched (using as select values);
        if (!data.hasOwnProperty('limit')) {
            return state.list = data;
        }

        state.items = data.items;
        state.pagination = {
            page: data.page || 1,
            totalPages: data.totalPages || 1
        };
    }
};
